import styled from "styled-components";

export const InvalidIbanImg = styled.img`
    margin: auto;
    max-height: 250px;
`;